import Dashboard from "components/dashboard/dashboard";
import Profile from "components/profile/profile";
import Product from "components/product/product";
import Comment from "components/comment/comment";
import Price from "components/price/price";
import Timing from "components/timing/timing";
import Duplicate from "components/duplicate/duplicate";
import OrderDetail from "components/order/order";
import Transactions from "components/transactions/transactions";
import Discounts from "components/discounts/discounts";
import Checkout from "components/checkout/checkout";
import Ticket from "components/ticket/ticket";
import Message from "components/message/message";
import SendMethods from "components/send-methods/send-methods";
import Help from "components/help/help";
import UserProfile from "components/user-profile/user-profile";
import { productFormId } from "./config";
import PasswordSetting from "components/password-setting/password-setting";
import AddProduct from "components/add-product/add-product";

const routes = [
    {
        id: 1,
        title: "پیشخوان",
        icon: "fa-house",
        view: <Dashboard />,
        index: true,
        route: "/panel",
        permissionUrl: ["/api/summary/dashboard"]
    },
    {
        id: 2,
        title: "مدیریت فروشگاه",
        icon: "fa-cart-shopping",
        childs: [
            {
                id: "order",
                title: "سفارشات",
                route: "/panel/order",
                params: [":id"],
                view: <OrderDetail template="order" key="order" />,
                permissionUrl: [
                    "/api/financial/order/list",
                    "/api/financial/order/detail",
                    "/api/financial/order/cancel",
                    "/api/financial/order/confirm",
                    "/api/financial/order/delivered_to_customer",
                    "/api/financial/order/delivery/status",
                ]
            },
            {
                id: "content",
                route: "/panel/content",
                title: "فهرست محصولات",
                view: <Product template="product" key="product" />,
                params: [":id", "add/:addId"],
                extendRoute: `?form_id=${productFormId}`,
                permissionUrl: ["/api/content/list"]
            },
            {
                id: "addProduct",
                route: "/panel/add-product",
                title: "افزودن محصول",
                view: <AddProduct key="addProduct" />,
                params: [],
                permissionUrl: ["/api/search/search"],
                extendRoute: `?form_id=${productFormId}`,
            },
            {
                id: "content",
                route: "/panel/duplicate",
                title: "قالب محتوا",
                view: <Duplicate template="product" key="product" />,
                params: [":id"],
                extendRoute: `?form_id=${productFormId}`,
                show: false,
                permissionUrl: ["/api/content/list"]
            },
            {
                id: "price",
                title: "لیست قیمت",
                route: "/panel/price",
                view: <Price template="price" />,
                extendRoute: `?form_id=${productFormId}`,
                permissionUrl: ["/api/content/list", "/api/content/edit_module_fields_multiple"]
            },
            {
                id: "discounts",
                title: "مدیریت تخفیفات",
                route: "/panel/discounts",
                view: <Discounts />,
                show: false,
                permissionUrl: ["/api/shop/discount/"]
            },
        ]
    },

    {
        id: 4,
        title: "امور مالی",
        icon: "fa-wallet",
        childs: [
            {
                id: "transactions",
                title: "تراکنشها",
                route: "/panel/transactions",
                params: [":id"],
                view: <Transactions template="transactions" key="transactions" />,
                permissionUrl: [
                    "/api/financial/balance/history",
                    "/api/financial/balance/history/:id",
                ]
            },
            {
                id: "checkout",
                title: "تسویه حساب",
                route: "/panel/checkout",
                params: [":id"],
                view: <Checkout template="checkout" key="checkout" />,
                permissionUrl: [
                    "/api/financial/summary",
                    "/api/financial/balance/withdraw",
                    "/api/financial/balance/withdraw/history",
                    "/api/financial/balance/withdraw/history/:id"
                ],
            },
        ]
    },
    {
        id: 6,
        title: "تعاملات کاربران",
        icon: "fa-envelope",
        childs: [
            {
                id: "comment",
                title: "نظرات",
                route: "/panel/comment",
                params: [":id"],
                view: <Comment template="comment" key="comment" />,
                permissionUrl: [
                    "/api/comment/list",
                    "/api/comment/get",
                    "/api/comment/reply"
                ]
            },
            {
                id: "ticket",
                title: "تیکت",
                route: "/panel/ticket",
                params: [":id"],
                view: <Ticket template="ticket" key="ticket" />,
                permissionUrl: [
                    "/api/ticket/create",
                    "/api/ticket/list",
                    "/api/ticket/get",
                    "/api/ticket/reply",
                    "/api/ticket/list_replies",
                    "/api/ticket/close",
                    "/api/ticket/set_is_useful"
                ]
            },
            {
                id: "message",
                title: "پیام ها",
                route: "/panel/message",
                params: [":id"],
                view: <Message template="message" key="message" />,
                permissionUrl: [
                    "/api/message/list",
                    "/api/message/get",
                    "/api/message/unseen_count",
                    "/api/message/set_seen"
                ]
            },
        ]
    },
    {
        id: 3,
        title: "اطلاعات فروشگاه",
        icon: "fa-palette",
        childs: [
            {
                title: "گزینه های ارسال",
                id: "sendMethods",
                route: "/panel/sendMethods",
                view: <SendMethods />,
                permissionUrl: [
                    "/api/profile/get",
                    "/api/profile/edit_module_fields",
                ]
            },
            {
                title: "ساعت کاری فروشنده",
                id: "timing",
                route: "/panel/timing",
                view: <Timing />,
                permissionUrl: [
                    "/api/profile/get",
                    "/api/profile/edit_module_fields",
                ]
            },
            {
                id: "profile",
                title: "اطلاعات فروشگاه",
                route: "/panel/profile",
                view: <Profile />,
                params: [":id", "add/:addId"],
                permissionUrl: [
                    "/api/profile/get",
                    "/api/profile/edit"
                ]
            },
            {
                id: "userProfile",
                title: "اطلاعات کاربر",
                route: "/panel/userProfile",
                view: <UserProfile template="user-profile" />,
                show: false
            },
        ]
    },
    {
        id: 7,
        title: "راهنما و آموزش",
        route: "/panel/help",
        icon: "fa-screwdriver-wrench",
        view: <Help />
    },
    {
        id: 8,
        title: "تنظیمات رمزعبور",
        route: "/panel/password-setting",
        icon: "",
        view: <PasswordSetting />,
        show: false
    }
];

export default routes;